import React from "react";
import MicrosoftLogin from "react-microsoft-login";
import "../styles/pages/Login.css";
import petraLogo from "../images/petra_logo.png";
import { Redirect, RouteComponentProps } from "react-router";
import { request } from "../helpers/utilities";
import { Row, Col, Spin, Alert, Input } from "antd";
import { AxiosResponse } from "axios";
import { GET_CURRENT_USER } from "../gql/users";

interface State {
  redirect: boolean;
  error: string;
  authenticating: boolean;
}

interface Props extends Partial<RouteComponentProps> {
  updateLoggedInStatus: (value: boolean) => void;
}

const tenantUrl = `https://login.microsoftonline.com/${
  process.env.REACT_APP_MICROSOFT_TENANT_ID as string
}`;

export default class Login extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      redirect: false,
      error: "",
      authenticating: false,
    };
  }

  getCurrentUser = (): void => {
    this.setState({ authenticating: true });
    request({
      query: GET_CURRENT_USER,
    })
      .then(({ data }: AxiosResponse<any>): void => {
        this.storeUserDataInLocalStorage(data.data.currentUser);
        this.redirectAndUpdateLoggedInStatus();
      })
      .catch((): void => {
        this.setState({
          error: "Login Failed",
          authenticating: false,
        });
      });
  };

  storeUserDataInLocalStorage = (user: Record<string, unknown>): void => {
    localStorage.setItem("user", JSON.stringify(user));
  };

  redirectAndUpdateLoggedInStatus = (): void => {
    this.setState({ redirect: true }, (): void => {
      const { updateLoggedInStatus } = this.props;
      updateLoggedInStatus(true);
    });
  };

  testLogin = (): void => {
    this.getCurrentUser();
  };

  componentDidMount(): void {
    document.title = "Phoenix - Login";
    const token = localStorage.getItem("msal.idtoken");
    token != null ? this.getCurrentUser() : console.log("No token");
  }

  handleMicrosoftResponse = (err: any, result: any) => {
    if (!err) {
      this.getCurrentUser();
    } else {
      console.log(err);
      this.setState({ error: "Login Failed - An issue occured" });
    }
  };

  handleApiUrlInput = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    e.persist();
    const url: string = e.target.value;
    localStorage.setItem("apiUrl", url);
  };

  render(): JSX.Element {
    const { authenticating, error } = this.state;

    const canBypassOAuth =
      window.location.origin.indexOf("https://phoenix-web--review-pr-") === 0 ||
      window.location.origin.indexOf("https://phoenix-staging") === 0 ||
      window.location.origin === "http://localhost:3000";

    if (this.state.redirect) {
      const urlParams = new URLSearchParams(window.location.search);
      const redirectParam = urlParams.get("redirect");

      const { location } = this.props;
      const state = location?.state as
        | { from?: { pathname: string; search?: string; hash?: string } }
        | undefined;

      let redirectPath = "/";
      if (redirectParam) {
        try {
          const url = new URL(redirectParam, window.location.origin);
          if (
            url.origin === window.location.origin &&
            url.pathname !== "/login"
          ) {
            redirectPath = url.pathname + url.search + url.hash;
          }
        } catch (e) {
          // Treat as invalid URL and default to "/"
        }
      } else if (state?.from && state.from.pathname !== "/login") {
        redirectPath = `${state.from.pathname}${state.from.search || ""}${
          state.from.hash || ""
        }`;
      }

      return <Redirect to={redirectPath} />;
    }

    return (
      <div className="login-page-container">
        <Row
          style={{
            height: "100vh",
          }}
        >
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            span={12}
            id="microsoft-login-col"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div id="microsoft-login-button-container">
              {error && (
                <Alert
                  style={{
                    textAlign: "center",
                    position: "relative",
                    bottom: "10px",
                  }}
                  type="error"
                  message={error}
                />
              )}
              {authenticating && (
                <span>
                  <Spin style={{ width: "1.5rem", height: "1.5rem" }} />
                  {" Authenticating ..."}
                </span>
              )}
              {!authenticating &&
                window.location.origin.indexOf(
                  "https://phoenix-web--review-pr-",
                ) === -1 && (
                  <div>
                    <MicrosoftLogin
                      clientId={
                        process.env.REACT_APP_MICROSOFT_CLIENT_ID as string
                      }
                      tenantUrl={tenantUrl}
                      authCallback={this.handleMicrosoftResponse}
                      prompt="select_account"
                      useLocalStorageCache={true}
                    />
                  </div>
                )}

              <div>
                {!authenticating && canBypassOAuth && (
                  <div>
                    <button
                      data-cy="test-login-button"
                      className="test-login-btn"
                      onClick={this.testLogin}
                    >
                      <span
                        style={{
                          margin: "0 auto",
                        }}
                      >
                        Test Login
                      </span>
                    </button>
                    <Input
                      style={{
                        display: "block",
                        marginTop: "20px",
                        width: "220px",
                        height: "40px",
                      }}
                      onChange={this.handleApiUrlInput}
                      placeholder={"Enter API URL"}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            span={12}
            className="bg-petra-blue"
            id="petra-banner-col"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div id="petra-logo-container">
              <img
                src={petraLogo}
                className="img-fluid"
                style={{ width: "250px" }}
                alt="Logo"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
